export default {
  "trigger": "Score by voice",
  "examplesButton": "What can I say?",
  "example": "“{first} one over, {second} birdie”",
  "title": "VOICE SCORE",
  "states": {
    "requesting_permission": "Getting microphone ready…",
    "listening": "Listening…",
    "processing_recording": "Processing recording…",
    "transcribing": "Transcribing…",
    "interpreting": "Understanding your scores…",
    "review": "Check these scores",
    "error": "Voice scoring"
  },
  "cancel": "Cancel",
  "done": "Done",
  "heard": "Heard: “{transcript}”",
  "strokes": "strokes",
  "decrease": "Decrease {name} proposed score",
  "increase": "Increase {name} proposed score",
  "labels": {
    "holeInOne": "Hole in one",
    "albatross": "Albatross",
    "eagle": "Eagle",
    "birdie": "Birdie",
    "par": "Par",
    "bogey": "Bogey",
    "doubleBogey": "Double bogey",
    "tripleBogey": "Triple bogey"
  },
  "correction": "Correction heard: “{phrase}”",
  "repair": "Confirm interpretation: “{original}” was understood as “{replacement}”.",
  "repairSuggestion": "Possible interpretation: “{original}” may mean “{replacement}”. Confirm the actual strokes below.",
  "subset": "Only the understood scores will be applied. Unresolved entries will not be saved.",
  "retry": "Try again",
  "apply": "Apply scores",
  "applySubset": "Apply understood scores",
  "manual": "Use manual scoring",
  "clarification": "Needs clarification",
  "player": "Player",
  "choosePlayer": "Choose a player",
  "gross": "Gross strokes",
  "confirmEntry": "Confirm this score",
  "skip": "Leave this entry out",
  "errors": {
    "interpretationFailure": "We couldn’t interpret those scores. Try again or use manual scoring.",
    "unavailable": "Voice scoring is unavailable right now. Please use manual scoring.",
    "microphone_permission_denied": "Microphone access is turned off for Privana. Open device settings, enable Microphone for Privana, then try again.",
    "microphone_unavailable": "We couldn’t access your microphone. Try again.",
    "media_recorder_unavailable": "Voice recording isn’t supported on this device.",
    "empty_audio": "We didn’t catch any audio.",
    "unsupported_audio": "This device recorded an unsupported audio format.",
    "upload_failed": "We couldn’t send that recording. Check your connection and try again.",
    "no_speech": "We didn’t catch any speech.",
    "transcription_failed": "We couldn’t transcribe that. Try again.",
    "voice_timeout": "Voice scoring took too long. Try again or use manual scoring.",
    "recording_failed": "We couldn’t record your voice. Try again.",
    "saveFailure": "Some scores could not be queued. Keep this review open and try again."
  }
}
